import { LabelsMap } from 'new/form/common/types';

export const termsAndConditionsSectionLabelsMap: LabelsMap = {};
